import { styled, useTheme } from '@mui/material';
import { useLocation, useParams } from 'react-router';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import { ROUTES } from '../../constants/routes';
import { useMonthlySingleTimesheet } from '../../queries/hooks/useMonthlySingleTimesheet';
import { getMonthLabel } from '../../utils/formatters';
import { ContentWrapper } from '../layout/styled';
import { AccountantSingleTimesheetTable } from './components/AccountantSingleTimesheetTable';
import { AccountantMonthFillView } from './components/AccountantMonthFillView';
import { useAtomValue } from 'jotai';
import { isSmallScreenState } from '../../state/UIState';
import { TimesheetStatus } from '../../types';

export function AccountantSingleTimesheet() {
  const { id } = useParams();
  const location = useLocation();
  const isSmallScreen = useAtomValue(isSmallScreenState);

  const { colors } = useTheme();
  const { data: singleTimesheet } = useMonthlySingleTimesheet({
    id: Number(id),
  });

  const breadcrumbTitle = singleTimesheet
    ? `${getMonthLabel(singleTimesheet.month)}, ${singleTimesheet.year}`
    : '';

  return (
    <PageWrapper isSmallScreen={isSmallScreen}>
      <Wrapper isSmallScreen={isSmallScreen}>
        <Breadcrumbs
          breadcrumbs={[
            location?.state?.from === ROUTES.TIMESHEET_APPROVALS
              ? {
                  title: 'Timesheet Approvals',
                  url: `/${ROUTES.TIMESHEET_APPROVALS}`,
                  color: colors.textAccent.default,
                }
              : {
                  title: 'Timesheet Statuses',
                  url: `/${ROUTES.ACCOUNTANT_TIMESHEETS_STATUSES}`,
                  color: colors.textAccent.default,
                },
            { title: breadcrumbTitle || '' },
          ]}
        />
      </Wrapper>
      <ContentWrapper isSmallScreen={isSmallScreen}>
        {singleTimesheet?.status === TimesheetStatus.ISSUED ? (
          <AccountantMonthFillView timesheet={singleTimesheet} />
        ) : (
          <AccountantSingleTimesheetTable />
        )}
      </ContentWrapper>
    </PageWrapper>
  );
}
const Wrapper = styled('div')<{ isSmallScreen: boolean }>`
  padding: ${({ isSmallScreen }) => (isSmallScreen ? '8px 16px' : '28px 36px 0')};
`;

const PageWrapper = styled('div')<{ isSmallScreen: boolean }>`
  padding-top: ${({ isSmallScreen }) => (isSmallScreen ? '48px' : '0px')};
`;
